import { render, staticRenderFns } from "./StandingsPageWrapper.vue?vue&type=template&id=1120f4c0&scoped=true"
import script from "./StandingsPageWrapper.vue?vue&type=script&lang=ts"
export * from "./StandingsPageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./StandingsPageWrapper.vue?vue&type=style&index=0&id=1120f4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120f4c0",
  null
  
)

export default component.exports